import { render } from "./TestimonialData.vue?vue&type=template&id=9d64e690&scoped=true"
import script from "./TestimonialData.vue?vue&type=script&lang=js"
export * from "./TestimonialData.vue?vue&type=script&lang=js"

import "./TestimonialData.vue?vue&type=style&index=0&id=9d64e690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d64e690"]])

export default __exports__